import { fromJS, List, Map } from 'immutable';

import {
  GET_USER_PROFILE,
  GET_USER_PROFILE_SUCCESS,
  GET_USER_PROFILE_FAILURE,
  GET_BUSINESS_ATTRIBUTES,
  GET_BUSINESS_ATTRIBUTES_SUCCESS,
  GET_BUSINESS_ATTRIBUTES_FAILURE,
  EDIT_USER_PROFILE,
  EDIT_USER_PROFILE_CANCELLED,
  UPDATE_USER_PROFILE,
  UPDATE_USER_PROFILE_SUCCESS,
  UPDATE_USER_PROFILE_FAILURE,
  RESET_USER_PROFILE_STATE,
  SET_USER_PROFILE_CUSTOM_ATTRIBUTE,
  UPDATE_BUSINESS_ATTRIBUTES,
  UPDATE_BUSINESS_ATTRIBUTES_SUCCESS,
  UPDATE_BUSINESS_ATTRIBUTES_FAILURE,
} from '../actions/actionTypes';
import { VIEWABLE_FORM_MODES, USER_PROFILE_TYPES } from '../../constants';

const initialState = fromJS({
  username: '',
  userAttributes: {},
  businessAttributes: {},
  isGettingBusinessAttributs: false,
  isGettingUserProfile: false,
  isUpdatingPersonalProfile: false,
  isUpdatingBusinessProfile: false,
  isUpdatingAdditionalInfo: false,
  isUpdatingServiceArea: false,
  personalProfileFormMode: VIEWABLE_FORM_MODES.VIEWING,
  businessProfileFormMode: VIEWABLE_FORM_MODES.VIEWING,
  additionalInfoFormMode: VIEWABLE_FORM_MODES.VIEWING,
  serviceAreaFormMode: VIEWABLE_FORM_MODES.VIEWING,
  // this is used to store the old userAttributes before an updating is made,
  // so that when an updating operation fails, we can set the value
  // of 'userAttributes' to be the old userAttributes
  oldUserAttributes: {},
});

// eslint-disable-next-line consistent-return
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_PROFILE:
      return state.set('isGettingUserProfile', true);
    case GET_USER_PROFILE_SUCCESS: {
      const userAttributesObj = {};
      action.userAttributes.forEach(attribute => {
        userAttributesObj[attribute.Name] = attribute.Value;
      });

      return state
        .set('isGettingUserProfile', false)
        .set('username', action.username)
        .set('userAttributes', fromJS(userAttributesObj));
    }
    case GET_USER_PROFILE_FAILURE:
      return state.set('isGettingUserProfile', false);
    case GET_BUSINESS_ATTRIBUTES:
      return state.set('isGettingBusinessAttributes', true);
    case GET_BUSINESS_ATTRIBUTES_SUCCESS:
      return state
        .set('isGettingBusinessAttributes', false)
        .set('businessAttributes', fromJS(action.businessAttributes));
    case GET_BUSINESS_ATTRIBUTES_FAILURE:
      return state.set('isGettingBusinessAttributes', false);
    case EDIT_USER_PROFILE: {
      switch (action.profileType) {
        case USER_PROFILE_TYPES.PERSONAL:
          return state.set(
            'personalProfileFormMode',
            VIEWABLE_FORM_MODES.EDITING,
          );
        case USER_PROFILE_TYPES.BUSINESS:
          return state.set(
            'businessProfileFormMode',
            VIEWABLE_FORM_MODES.EDITING,
          );
        case USER_PROFILE_TYPES.ADDITIONAL:
          return state.set(
            'additionalInfoFormMode',
            VIEWABLE_FORM_MODES.EDITING,
          );
        case USER_PROFILE_TYPES.SERVICE_AREA:
          return state.set('serviceAreaFormMode', VIEWABLE_FORM_MODES.EDITING);
        default:
          // eslint-disable-next-line no-console
          console.log('reached switch default');
      }
      break;
    }
    case EDIT_USER_PROFILE_CANCELLED: {
      switch (action.profileType) {
        case USER_PROFILE_TYPES.PERSONAL:
          return state.set(
            'personalProfileFormMode',
            VIEWABLE_FORM_MODES.VIEWING,
          );
        case USER_PROFILE_TYPES.BUSINESS:
          return state.set(
            'businessProfileFormMode',
            VIEWABLE_FORM_MODES.VIEWING,
          );
        case USER_PROFILE_TYPES.ADDITIONAL:
          return state.set(
            'additionalInfoFormMode',
            VIEWABLE_FORM_MODES.VIEWING,
          );
        case USER_PROFILE_TYPES.SERVICE_AREA:
          return state.set('serviceAreaFormMode', VIEWABLE_FORM_MODES.VIEWING);
        default:
          // eslint-disable-next-line no-console
          console.log('reached switch default');
      }
      break;
    }
    case UPDATE_USER_PROFILE: {
      const oldUserAttributes = state.get('userAttributes');
      const newUserAttributes = oldUserAttributes.merge(
        Map(action.userAttributes),
      );
      const newState = state
        .set('userAttributes', newUserAttributes)
        .set('oldUserAttributes', oldUserAttributes);

      switch (action.profileType) {
        case USER_PROFILE_TYPES.PERSONAL:
          return newState.set('isUpdatingPersonalProfile', true);
        case USER_PROFILE_TYPES.BUSINESS:
          return newState.set('isUpdatingBusinessProfile', true);
        case USER_PROFILE_TYPES.SERVICE_AREA:
          return newState.set('isUpdatingServiceArea', true);
        case USER_PROFILE_TYPES.ADDITIONAL:
          return newState.set('isUpdatingAdditionalInfo', true);
        default:
          // eslint-disable-next-line no-console
          console.log('reached switch default');
      }
      break;
    }
    case UPDATE_USER_PROFILE_SUCCESS: {
      const newState = state.set('oldUserAttributes', List([]));

      switch (action.profileType) {
        case USER_PROFILE_TYPES.PERSONAL:
          return newState
            .set('isUpdatingPersonalProfile', false)
            .set('personalProfileFormMode', VIEWABLE_FORM_MODES.VIEWING);
        case USER_PROFILE_TYPES.BUSINESS:
          return newState
            .set('isUpdatingBusinessProfile', false)
            .set('businessProfileFormMode', VIEWABLE_FORM_MODES.VIEWING);
        case USER_PROFILE_TYPES.SERVICE_AREA:
          return newState
            .set('isUpdatingServiceArea', false)
            .set('serviceAreaFormMode', VIEWABLE_FORM_MODES.VIEWING);
        case USER_PROFILE_TYPES.ADDITIONAL:
          return newState
            .set('isUpdatingAdditionalInfo', false)
            .set('additionalInfoFormMode', VIEWABLE_FORM_MODES.VIEWING);
        default:
          // eslint-disable-next-line no-console
          console.log('reached switch default');
      }
      break;
    }
    case UPDATE_USER_PROFILE_FAILURE: {
      const oldUserAttributes = state.get('oldUserAttributes');
      const newState = state
        .set('oldUserAttributes', List([]))
        .set('userAttributes', oldUserAttributes);

      switch (action.profileType) {
        case USER_PROFILE_TYPES.PERSONAL:
          return newState.set('isUpdatingPersonalProfile', false);
        case USER_PROFILE_TYPES.BUSINESS:
          return newState.set('isUpdatingBusinessProfile', false);
        case USER_PROFILE_TYPES.SERVICE_AREA:
          return newState.set('isUpdatingServiceArea', false);
        case USER_PROFILE_TYPES.ADDITIONAL:
          return newState.set('isUpdatingAdditionalInfo', false);
        default:
          // eslint-disable-next-line no-console
          console.log('reached switch default');
      }
      break;
    }
    case UPDATE_BUSINESS_ATTRIBUTES: {
      const oldBusinessAttributes = state.get('businessAttributes');
      const newBusinessAttributes = oldBusinessAttributes.merge(
        Map(action.businessAttributes),
      );
      const newState = state
        .set('businessAttributes', newBusinessAttributes)
        .set('oldBusinessAttributes', oldBusinessAttributes);

      switch (action.profileType) {
        case USER_PROFILE_TYPES.PERSONAL:
          return newState.set('isUpdatingPersonalProfile', true);
        case USER_PROFILE_TYPES.BUSINESS:
          return newState.set('isUpdatingBusinessProfile', true);
        case USER_PROFILE_TYPES.SERVICE_AREA:
          return newState.set('isUpdatingServiceArea', true);
        default:
          // eslint-disable-next-line no-console
          console.log('reached switch default');
      }
      break;
    }
    case UPDATE_BUSINESS_ATTRIBUTES_SUCCESS: {
      const newState = state.set('oldBusinessAttributes', List([]));

      switch (action.profileType) {
        case USER_PROFILE_TYPES.PERSONAL:
          return newState
            .set('isUpdatingPersonalProfile', false)
            .set('personalProfileFormMode', VIEWABLE_FORM_MODES.VIEWING);
        case USER_PROFILE_TYPES.BUSINESS:
          return newState
            .set('isUpdatingBusinessProfile', false)
            .set('businessProfileFormMode', VIEWABLE_FORM_MODES.VIEWING);
        case USER_PROFILE_TYPES.SERVICE_AREA:
          return newState
            .set('isUpdatingServiceArea', false)
            .set('serviceAreaFormMode', VIEWABLE_FORM_MODES.VIEWING);
        default:
          // eslint-disable-next-line no-console
          console.log('reached switch default');
      }
      break;
    }
    case UPDATE_BUSINESS_ATTRIBUTES_FAILURE: {
      const oldBusinessAttributes = state.get('oldBusinessAttributes');
      const newState = state
        .set('oldBusinessAttributes', List([]))
        .set('businessAttributes', oldBusinessAttributes);

      switch (action.profileType) {
        case USER_PROFILE_TYPES.PERSONAL:
          return newState.set('isUpdatingPersonalProfile', false);
        case USER_PROFILE_TYPES.BUSINESS:
          return newState.set('isUpdatingBusinessProfile', false);
        case USER_PROFILE_TYPES.SERVICE_AREA:
          return newState.set('isUpdatingServiceArea', false);
        default:
          // eslint-disable-next-line no-console
          console.log('reached switch default');
      }
      break;
    }
    case SET_USER_PROFILE_CUSTOM_ATTRIBUTE: {
      return state.setIn(['userAttributes', action.key], action.value);
    }
    case RESET_USER_PROFILE_STATE:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
